// src/components/PendenciaTable.js
import React from "react";
import {
  RiErrorWarningLine,
  RiCalendarLine,
  RiUser3Line,
  RiEdit2Line,
} from "react-icons/ri";
import {
  PendenciaInfoContainer,
  PendenciaInfoRow,
  PendenciaValue,
  CustomTableCell,
  CustomTableHeader,
  Table,
} from "../styles/StyledPendenciaComponents";
import { ActionButton } from "../styles/StyledComponents";

const PendenciaTable = ({ pendencias, onEdit }) => {
  const truncateText = (text, maxLength) => {
    return text && text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <Table>
      <thead>
        <tr>
          <CustomTableHeader align="left">Equipamento</CustomTableHeader>
          <CustomTableHeader align="left">Tipo Contrato</CustomTableHeader>
          <CustomTableHeader align="left">Cliente</CustomTableHeader>
          <CustomTableHeader align="left">Técnico</CustomTableHeader>
          <CustomTableHeader align="left">Data</CustomTableHeader>
          <CustomTableHeader align="left">Descrição</CustomTableHeader>
          <CustomTableHeader align="right">Ações</CustomTableHeader>
        </tr>
      </thead>
      <tbody>
        {pendencias.map((pendencia) => (
          <tr key={pendencia._id}>
            <CustomTableCell width={120}>
              <PendenciaInfoContainer>
                <PendenciaInfoRow>
                  <RiErrorWarningLine
                    style={{ color: "#888", fontSize: "15px", marginRight: "5px" }}
                  />
                  <PendenciaValue>{pendencia.equipamentoNumero || "-"}</PendenciaValue>
                </PendenciaInfoRow>
              </PendenciaInfoContainer>
            </CustomTableCell>

            <CustomTableCell width={120}>
              <PendenciaInfoContainer>
                <PendenciaInfoRow>
                  <RiErrorWarningLine
                    style={{ color: "#888", fontSize: "15px", marginRight: "5px" }}
                  />
                  <PendenciaValue>{pendencia.tipoContrato || "-"}</PendenciaValue>
                </PendenciaInfoRow>
              </PendenciaInfoContainer>
            </CustomTableCell>

            <CustomTableCell width={200}>
              <PendenciaInfoContainer>
                <PendenciaInfoRow>
                  <RiUser3Line
                    style={{ color: "#888", fontSize: "15px", marginRight: "5px" }}
                  />
                  <PendenciaValue>{pendencia.building || "-"}</PendenciaValue>
                </PendenciaInfoRow>
              </PendenciaInfoContainer>
            </CustomTableCell>

            <CustomTableCell width={200}>
              <PendenciaInfoContainer>
                <PendenciaInfoRow>
                  <RiUser3Line
                    style={{ color: "#888", fontSize: "15px", marginRight: "5px" }}
                  />
                  <PendenciaValue>{pendencia.tecnico?.name || "-"}</PendenciaValue>
                </PendenciaInfoRow>
              </PendenciaInfoContainer>
            </CustomTableCell>

            <CustomTableCell width={150}>
              <PendenciaInfoContainer>
                <PendenciaInfoRow>
                  <RiCalendarLine
                    style={{ color: "#888", fontSize: "15px", marginRight: "5px" }}
                  />
                  <PendenciaValue>
                    {new Date(pendencia.dataApontamento).toLocaleDateString() || "-"}
                  </PendenciaValue>
                </PendenciaInfoRow>
              </PendenciaInfoContainer>
            </CustomTableCell>

            <CustomTableCell width={300}>
              <PendenciaInfoContainer>
                <PendenciaInfoRow>
                  <PendenciaValue>
                    {truncateText(pendencia.descricaoPendencia, 50) || "-"}
                  </PendenciaValue>
                </PendenciaInfoRow>
              </PendenciaInfoContainer>
            </CustomTableCell>

            <CustomTableCell align="right">
              <ActionButton onClick={() => onEdit(pendencia)}>
                <RiEdit2Line />
              </ActionButton>
            </CustomTableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default PendenciaTable;
